// https://github.com/biati-digital/glightbox

import GLightbox from 'glightbox'

GLightbox({
  loop: false
})
